import { render, staticRenderFns } from "./image-control-box.vue?vue&type=template&id=4e05ed1e&scoped=true&"
import script from "./image-control-box.vue?vue&type=script&lang=js&"
export * from "./image-control-box.vue?vue&type=script&lang=js&"
import style0 from "./image-control-box.vue?vue&type=style&index=0&id=4e05ed1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05ed1e",
  null
  
)

export default component.exports